<div *ngIf="!spinner; else spinnerBlock">
  <div class="timeline-alt" *ngIf="dataToDisplay.length; else noDataFound">
    <div *ngFor="let data of dataToDisplay; let i = index">
      <div *ngFor="let records of data.data" class="time-slot">
        <div>
          <div
            class="status-dot"
            [class.online]="records.status === 'online'"
            [class.offline]="records.status === 'offline'"
            [ngStyle]="{ 'margin-top': records.height + 'px' }"
          >
            <!-- [ngStyle]="{ height: records.height + 'px' }" -->
            <div class="ta-time">{{ records.time }}</div>
          </div>
        </div>
      </div>
      <div class="ta-date">{{ data.date }}</div>
    </div>
  </div>
  <ng-template #noDataFound>
    <div class="no-data-found">
      <div class="no-data-found-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <div class="text-center no-result-entry">No Data Found</div>
    </div>
  </ng-template>
</div>
<ng-template #spinnerBlock>
  <div class="spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>
